import type {TFunction} from 'i18next';
import {z} from 'zod';

export const form201Schema = (t: TFunction<'translation', undefined>) =>
    z.object({
        specialEducationServices: z.string({message: `${t('requiredErrorFull')}`}),
        section504: z.string({message: `${t('requiredErrorFull')}`}),
        englishLearner: z.string({message: `${t('requiredErrorFull')}`}),
    });
